module.exports = __webpack_public_path__ + "img/plane-engines.bfacd4d2.svg";